import React from "react";

export default function Nombre({todos}) {
return(
    <div>
        <h3> Nous sommes: {todos.length}</h3>
    </div>
)}